/** Normalize GET /sightseeing/getSightSeeing rows for dropdown use. */
export function normalizeSightseeingItem(item) {
  if (!item || typeof item !== 'object') return null;
  const rawId = item.id ?? item.sightSeeingId ?? item.sightseeingId;
  if (rawId == null || rawId === '') return null;
  return {
    ...item,
    id: String(rawId),
    sightSeeingName:
      item.sightSeeingName || item.sightseeingName || item.name || 'Unnamed sightseeing',
  };
}

export function normalizeSightseeingList(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeSightseeingItem).filter(Boolean);
}
